import { Injectable, Injector } from '@angular/core';
import { LBSErrorHandler, LBSErrorHandlerResult } from '../error-handler';
import { ActivityConfirmationsService } from '../../activity-confirmations/logic/activity-confirmations.service';

@Injectable({
  providedIn: 'root',
})
export class DraftAlreadyTakenOverErrorHandler implements LBSErrorHandler {
  constructor(private injector: Injector) {}

  public async handleError(error: Error, params?: { acId?: number }): Promise<LBSErrorHandlerResult> {
    // errmsg keys are lowercase with underscores by convention - the key was
    // renamed from ERR.DRAFT.ALREADY.TAKEN.OVER for APILevel 15.
    if (error?.['error']?.messageCode !== 'err_draft_already_taken_over') {
      return undefined;
    }

    if (params?.acId != undefined) {
      const activityConfirmationsService = this.injector.get(ActivityConfirmationsService);
      await activityConfirmationsService.markDraftConsumed(params.acId);
    }

    // Return undefined so RestErrorHandler still shows the error alert
    return undefined;
  }
}
